import React from "react";

/**
 * MetricCard
 * Standard card layout for key metrics across admin dashboards.
 * Provides consistent padding, typography, and responsive behavior.
 */
const variantClasses = {
	light: "bg-white text-slate-900 border border-slate-200",
	dark: "bg-slate-900 text-slate-50",
	accent: "bg-rose-600 text-rose-50",
};

function MetricCard({ icon, title, label, value, helper, variant = "light", className = "" }) {
	const bg = variantClasses[variant] || variantClasses.light;
	const isDark = variant === "dark";
	const isAccent = variant === "accent";
	const labelClass = isDark || isAccent ? "text-slate-100/80" : "text-secondary/80";
	const helperClass = isDark || isAccent ? "text-slate-100/80" : "text-secondary/90";

	return (
		<div className={`rounded-2xl p-4 md:p-5 shadow-sm ${bg} ${className}`}>
			{(title || icon) && (
				<div className="flex items-center gap-2 mb-3">
					{icon && <span className="text-xl">{icon}</span>}
					{title && <h4 className="text-sm font-medium md:text-base">{title}</h4>}
				</div>
			)}
			{label && <div className={`mb-1 text-xs font-medium uppercase tracking-wide ${labelClass}`}>{label}</div>}
			{value && <div className="text-xl font-semibold md:text-2xl">{value}</div>}
			{helper && <div className={`mt-1 text-xs ${helperClass}`}>{helper}</div>}
		</div>
	);
}

export default MetricCard;

